import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const uber: GetCustomerCopyFunc = () => {
  return {
    displaySessionLimit: false,
  }
}
